/* eslint-disable react/jsx-closing-tag-location */
import React, { useState, useEffect, useMemo } from 'react';
import { message, Tooltip } from 'antd';
import utils, { getQuery } from '@/common/utils';
import { isFunction } from 'lodash';
import { roomApi } from '@/apis';
import { useActivityInfo } from '@/components/activity-detail2';
import './index.less';
import { resetCrumbs, updateCrumbs } from '@/components/bread-crumbs';
import { withRouter } from 'react-router-dom';
import goto from '@/common/goto';
import Container from '@/components/container';
import query from '@/pages/channel-service/apis';

const poolInfoDataMap = [
  { label: '收品池编号', key: 'poolId' },
  { label: '收品类型', key: 'gatherType' },
  { label: '收品池介绍', key: 'description' },
];
const pooDataMap = [
  { label: '收品池名称', key: 'name' },
  { label: '收品类型', key: 'gatherType' },
  { label: '收品池介绍', key: 'description' },
];

const renderFilter = (typeMap = [], data = {}) => {
  return (
    <ul
      className="header-detail-list"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {typeMap.map((e) => {
        return (
          <p key={e.label}>
            <span className="info-key">{e.label} </span>
            <span className="info-value">{isFunction(e.renderFun, e.key) ? e.renderFun(data) : data[e.key]}</span>
          </p>
        );
      })}
    </ul>
  );
};

// 获取默认值
function getInitialPoolData(isCreateMode) {
  if (isCreateMode) return { poolId: '--', gatherType: '--', description: '--', name: '新建收品池' };
  return {};
}

/**
 * @param type 1 显示操作， 其他不显示
 */
const OperationHeader = (props) => {
  const { activityInfo, isCreateMode } = props;
  const tibaoId = getQuery('activityId');
  const poolId = getQuery('blockId');
  const entry = getQuery('entry');
  const [poolData, setPoolData] = useState(() => getInitialPoolData(isCreateMode));

  useEffect(() => {
    getPoolData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPoolData = async () => {
    if (!tibaoId || !poolId) return;
    const { ret, data, msg } = await roomApi.getRoomPoolDetail({
      tibaoId,
      poolId,
    });
    if (ret !== '0') {
      message.error(msg);
      return false;
    }
    setPoolData({ ...data, tibaoId, poolId });
  };

  // 日常活动中的收品池不会关联planCode
  const leftInfo = !!activityInfo.planCode && (
    <section
      className="market-info"
      onClick={() => goto.channelCollectionPoolList(activityInfo.planCode, entry, tibaoId).push()}
    >
      <title>{activityInfo.activityName}</title>
      <p>
        <span>活动ID：{activityInfo.planCode}</span>
      </p>
    </section>
  );

  return (
    <div className="operation-detail-header">
      <div className="info-area">
        {leftInfo}
        <section className="other-info">
          {poolData.name ? (
            <>
              <title>{poolData.name}</title>
              <p>
                {poolInfoDataMap.map((e) => {
                  return (
                    <span key={e.label}>
                      {e.label}: {poolData[e.key]}
                    </span>
                  );
                })}
                {isCreateMode ? null : (
                  <Tooltip
                    placement="bottom"
                    overlayClassName="tool-tip-warp"
                    title={renderFilter(pooDataMap, poolData)}
                  >
                    <a className="tool-tip">详情</a>
                  </Tooltip>
                )}
              </p>
            </>
          ) : null}
        </section>
      </div>
    </div>
  );
};

const OperationHeaderWapper = (props) => {
  const planCode = utils.getQuery('planCode');
  const [activityInfo = {}, loadStatus] = useActivityInfo(planCode);
  useEffect(() => {
    if (!planCode) return;
    if (!activityInfo.channelCode) return;
    query.channelActivityGetChannel({ channelId: activityInfo.channelCode }).then((res) => {
      if (!res || res.ret !== '0' || !res.data) return;

      updateCrumbs({ ...activityInfo, _channelInfo: res.data });
    });

    return resetCrumbs;
  }, [planCode, activityInfo, activityInfo.channelCode]);

  // 创建模式
  const isCreateMode = useMemo(() => !utils.getQuery('blockId'), []);

  // 日常活动下
  const inNormalDay = useMemo(() => !utils.getQuery('planCode'), []);

  return (
    <>
      {inNormalDay && isCreateMode ? null : (
        <Container margin={false} padding>
          <OperationHeader isCreateMode={isCreateMode} activityInfo={activityInfo} />
        </Container>
      )}
      <Container>{props.children}</Container>
    </>
  );
};

export default withRouter(OperationHeaderWapper);
